interface FeedbackData {
  id?: number;
  type?: string;
  name?: string;
  rights?: string[];
}
export class Feedback {
  public static readonly TYPE_DAILY: string = 'daily';
  public static readonly TYPE_SESSION: string = 'session';

  public static getNonTranslatableFields(): string[] { return ['id', 'type', 'name']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'type', 'name']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  type?: string;
  name?: string;
  rights?: string[];


  public static fromAPI(data: FeedbackData): Feedback {
    return new Feedback(data);
  }


  public static fromAPIList(data: FeedbackData[]): Feedback[] {
    return data.map((item) => Feedback.fromAPI(item));
  }


   constructor(data: FeedbackData = {}) {
    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.rights = data.rights;
   }


  public toJson(): FeedbackData {
    return {
      id: this.id,
      type: this.type,
      name: this.name
    };
  }
}
